import { useAppSelector } from "../app/hook";
import { selectPermissions } from "../features/dashboard.slice";

const usePermission = (): Permissions => {
  const permissions = useAppSelector(selectPermissions);
  return permissions;
};

export default usePermission;

export interface Permissions {
  menu: Menu;
  widgetPage: WidgetPage;
  extensionPage: ExtensionPage;
  billingPage: BillingPage;
  settingsPage: SettingsPage;
  homePage: HomePage;
}

export interface Menu {
  home: boolean;
  widgets: boolean;
  billing: boolean;
  profile: boolean;
  extension: Extension;
  settings: boolean;
  support: boolean;
  downloadYourBot: DownloadYourBot;
}

export interface Extension {
  self: boolean;
  upgrade: boolean;
}

export interface DownloadYourBot {
  self: boolean;
  widget: Widget;
  extension: Extension2;
}

export interface Widget {
  self: boolean;
  active: boolean;
  upgrade: boolean;
}

export interface Extension2 {
  upgrade: boolean;
  active: boolean;
  self: boolean;
}

export interface WidgetPage {
  addNewBot: boolean;
  main: string[];
}

export interface ExtensionPage {
  addNewBot: boolean;
  upgrade: boolean;
  main: any[];
  qrcodeAvatarAccess: boolean;
}

export interface BillingPage {
  free: {
    monthly: boolean;
    yearly: boolean;
  };
  basic: {
    monthly: boolean;
    yearly: boolean;
  };
  advance: {
    monthly: boolean;
    yearly: boolean;
  };
}

export interface SettingsPage {
  openAi: OpenAi;
  widget: Widget2;
  extension: Extension3;
}

export interface OpenAi {
  maxToken: boolean;
  model: boolean;
  apiKey: boolean;
  upgrade: boolean;
}

export interface Widget2 {
  customApiKey: boolean;
  customization: Customization;
  visibilityControl: VisibilityControl;
  setDomain: SetDomain;
  self: boolean;
  upgrade: boolean;
}

export interface Customization {
  self: boolean;
  upgrade: boolean;
  voiceCommand: boolean;
  voiceResponse: boolean;
  defaultOpen: boolean;
  position: boolean;
  icon: boolean;
  theme: boolean;
  colors: boolean;
  avatar: boolean;
  name: boolean;
  poweredBy: boolean;
  userApiKeys: boolean;
  save_conversation: boolean;
  roundedVideo: boolean;
  alwaysShowButtons: boolean;
  notificationBadge: boolean;
  notificationMessage: boolean;
  notificationSound: boolean;
  isFullScreen: boolean;
  saveStats: boolean;
  sessionLimit: boolean;
}

export interface VisibilityControl {
  self: boolean;
  upgrade: boolean;
  operatingHours: OperatingHours;
  widgetVisibilityControl: WidgetVisibilityControl;
}

export interface OperatingHours {
  self: boolean;
  upgrade: boolean;
}

export interface WidgetVisibilityControl {
  self: boolean;
  upgrade: boolean;
}

export interface SetDomain {
  defaultDomain: DefaultDomain;
  localUse: LocalUse;
}

export interface DefaultDomain {
  self: boolean;
  upgrade: boolean;
}

export interface LocalUse {
  self: boolean;
  upgrade: boolean;
}

export interface Extension3 {
  name: boolean;
  avatar: boolean;
  colors: boolean;
  theme: boolean;
  voiceCommand: boolean;
  poweredBy: boolean;
  upgrade: boolean;
}

export interface HomePage {
  widget: Widget3;
  extension: Extension4;
  consumedSessions: ConsumedSessions;
  canCreate: CanCreate;
}

export interface Widget3 {
  createNewBot: boolean;
  upgrade: boolean;
  isDefaultBot: boolean;
}

export interface Extension4 {
  createNewBot: boolean;
  upgrade: boolean;
  isDefaultBot: boolean;
}

export interface ConsumedSessions {
  scenarioBots: boolean;
  aIBots: boolean;
}

export interface CanCreate {
  KITTY_01: Kitty01;
  CLONE_01: Clone01;
  KITTY_03: Kitty03;
  KITTY_04: Kitty04;
  MCBOT_01: Mcbot01;
  KITTY_02: Kitty02;
  VIDEO_SCENARIO: VideoScenario;
}

export interface Kitty01 {
  self: boolean;
  upgrade: boolean;
}

export interface Clone01 {
  self: boolean;
  upgrade: boolean;
}

export interface Kitty03 {
  self: boolean;
  upgrade: boolean;
}

export interface Kitty04 {
  self: boolean;
  upgrade: boolean;
}

export interface Mcbot01 {
  self: boolean;
  upgrade: boolean;
}

export interface Kitty02 {
  self: boolean;
  upgrade: boolean;
}

export interface VideoScenario {
  self: boolean;
  upgrade: boolean;
}
